import { render, staticRenderFns } from "./RegistrationBanner.vue?vue&type=template&id=aee57658&scoped=true&lang=pug&"
var script = {}
import style0 from "./RegistrationBanner.vue?vue&type=style&index=0&id=aee57658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee57658",
  null
  
)

export default component.exports